import toString from 'lodash/toString';

import { ApplicationUpdateMessage } from '../enums/ApplicationUpdateMessage';

export const isValidApplicationUpdateMessage = (
  applicationUpdateMessage:
    | keyof typeof ApplicationUpdateMessage
    | null
    | undefined,
): boolean => {
  if (!applicationUpdateMessage) {
    return false;
  }

  return Object.keys(ApplicationUpdateMessage).includes(
    toString(applicationUpdateMessage),
  );
};
